import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { DeleteOutline, Download, PreviewOutlined } from "@mui/icons-material";
import { IconButton } from "@mui/material";

import { SingleImageViewer } from "components/SingleImageViewer/SingleImageViewer";
import { getBlobDataUrl, isFileNamePdf, isImageFileName } from "core/file_utils";
import useEditing from "pages/Som/SomItem/hooks/useEditing";
import { deleteSomOfferJust } from "slices/som/services/deleteSomOfferJust";
import { downloadSomOfferJust } from "slices/som/services/downloadSomOfferJust";
import { fetchSomOfferJustImage } from "slices/som/services/fetchSomOfferJustImage";
import { previewSomOfferJust } from "slices/som/services/previewSomOfferJust";

import styles from "./JustificationsList.module.css";

export const JustificationsListItem = ({ justId, fileName, rowObj }) => {
	const dispatch = useDispatch();
	const { isEditingAllowed } = useEditing();
	const isImageJust = isImageFileName({ fileName });
	const isPdfJust = isFileNamePdf({ fileName });

	const getImageSrcData = useCallback(async () => {
		const resultAction = await dispatch(fetchSomOfferJustImage({ justId }));
		if (fetchSomOfferJustImage.fulfilled.match(resultAction)) {
			const blobData = resultAction.payload;
			const blobDataUrl = getBlobDataUrl(blobData);
			return blobDataUrl;
		}
		return "";
	}, [dispatch, justId]);

	return (
		<div className={styles.container}>
			<span className={styles.title}>{fileName}</span>
			<div className={styles.actions}>
				{isImageJust ? (
					<SingleImageViewer getSrcData={getImageSrcData}>
						<IconButton size="small">
							<PreviewOutlined sx={{ fontSize: "16px" }} />
						</IconButton>
					</SingleImageViewer>
				) : (
					<IconButton size="small" disabled={!isPdfJust} onClick={() => dispatch(previewSomOfferJust({ justId, fileName }))}>
						<PreviewOutlined sx={{ fontSize: "16px" }} />
					</IconButton>
				)}
				<IconButton size="small" onClick={() => dispatch(downloadSomOfferJust({ justId, fileName }))}>
					<Download sx={{ fontSize: "16px" }} />
				</IconButton>
				<IconButton size="small" onClick={() => dispatch(deleteSomOfferJust({ justId }))} disabled={!isEditingAllowed(rowObj, "EDIT")}>
					<DeleteOutline sx={{ fontSize: "16px" }} />
				</IconButton>
			</div>
		</div>
	);
};
